module.exports = __webpack_public_path__ + "media/images/svg/jobs/makeup-82b80e0b8cdef6fcd10af060a40455b6.svg";